import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@app/shared/ui/atoms/Common';
import { ImageBannerWithCTA } from '@app/shared/ui/organisms/Common';
import { pandaWithCardImage, questionIcon } from '@app/assets';

interface PandoraBankProps {
  onOpenModal: () => void;
}

export function PandoraBankSection({ onOpenModal }: PandoraBankProps) {
  const { t } = useTranslation();

  return (
    <section className="mb-5 mt-10 px-3">
      <ImageBannerWithCTA
        title={
          <>
            Pandora <span className="font-normal">{t('shop.bank')}</span>
          </>
        }
        imageProps={{ src: pandaWithCardImage, alt: 'panda-with-card', className: 'w-32' }}
        extraContent={
          <Button
            variant="custom"
            className="flex size-[30px] items-center justify-center rounded-full bg-accent"
            onClick={onOpenModal}
          >
            <img src={questionIcon} alt="question icon" className="w-3" />
          </Button>
        }
        buttonProps={{
          children: (
            <>
              {t('common.soon')} <Lock size="18" />
            </>
          ),
          onClick: onOpenModal,
        }}
        topOffset={70}
        bottomOffset={40}
      />
    </section>
  );
}
